import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PricingSection } from "@/components/home/PricingSection";
import { FinalCTA } from "@/components/home/Extras";
import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";

export default function PricingPage() {
  const { t } = useLang();
  const { content } = useContent();
  useEffect(() => {
    const seo = content?.seo?.pricing;
    document.title = seo?.title || "Pricing — Bezalel Visionary · Web Design Dubai";
    if (seo?.description) document.querySelector('meta[name="description"]')?.setAttribute("content", seo.description);
    window.scrollTo(0, 0);
  }, [content]);
  return (
    <main data-testid="pricing-page">
      <Navbar />
      <div className="bg-[#191713] pt-32 lg:pt-40 pb-4">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <h1 className="font-serif text-[#F7F3EC] text-4xl sm:text-5xl lg:text-6xl">{t.pricing.title}</h1>
        </div>
      </div>
      <PricingSection full />
      <FinalCTA />
      <Footer />
    </main>
  );
}
